// extracted by mini-css-extract-plugin
export default {"container":"market-resources-modal_container__v66+n"};